import { atomWithStorage } from 'jotai/utils';

export const insightsMineAtom = atomWithStorage('insights-mine', false, undefined, {
  getOnInit: true,
});
